import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
        },
      },
    },
  },
  typography: {
    fontFamily: 'Montserrat',
  },
  palette: {
    primary: {
      main: '#691B32',
      white: '#FFFFFF',
      black: '#000000',
      gold: '#BC955B',
      wine: '#691B32',
    },
    background: {
      default: '#f5f5f5',
      main: '#ffffff',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;